import * as constants from './constants'
import { storage, storageRef } from 'firebaseConfig/clientApp'
import { storageGetDownloadURL } from 'firebaseConfig/clientApp'
import { optionsMaker } from 'helpers/fetchOptions'
import { AppDispatch, RootState } from 'reducers/store'
import { updateToken } from './user'
import { isDev } from 'app/general'

const BASE_DOMAIN = process.env.API

export const getDownloadLink = async (imagePath: string, dispatch: any) => {
  dispatch({ type: constants.GET_IMAGE_DOWNLOAD_LINK_TRY })

  return await storageGetDownloadURL(storageRef(storage, imagePath))
    .then((url) => {
       isDev && console.log(url)
      return url
    })
    .catch((error) => {
       isDev && console.log(error)
      return null
    })
}

export const resetGoToPage = () => ({
  type: constants.RESET_GO_TO_PAGE,
})

export const resetLoading = () => ({
  type: constants.RESET_LOADING
})

export const setLoading = (state: boolean) => ({
  type: constants.SET_LOADING,
  state: state
})
export const addNotificationsToReducer = (notifications: any[]) => ({
  type: constants.ADD_NOTIFICATIONS_TO_REDUCER,
  notifications: notifications
})

export const toggleDebug = () => ({
  type: constants.TOGGLE_DEBUG,
})
export const setIsForeground = (isForeground: boolean) => ({
  type: constants.SET_IS_FOREGROUND,
  isForeground
})

export const setLastHomeRefresh = (lastHomeRefresh: number) => ({
  type: constants.SET_LAST_HOME,
  lastHomeRefresh: lastHomeRefresh
})

export const setLastPostsRefresh = (lastPostsRefresh: number) => ({
  type: constants.SET_LAST_POSTS,
  lastPostsRefresh: lastPostsRefresh
})

export enum EntryType {
  POST = "POST",
  COMMUNITY = "COMMUNITY",
  PAGE = "PAGE",
  EVENT = "EVENT",
  PROFILE = "PROFILE",
  PRODUCT = "PRODUCT",
  SERVICE = "SERVICE",
  JOB = "JOB",
  TICKET = "TICKET",
}

export const getHumanEntryType = (entryType: EntryType) => {
  switch (entryType) {
    case EntryType.POST: return "POST"
    case EntryType.COMMUNITY: return "COMMUNITY"
    case EntryType.PAGE: return "PAGE"
    case EntryType.EVENT: return "EVENT"
    case EntryType.PROFILE: return "PROFILE"
    case EntryType.PRODUCT: return "SELL AN ITEM"
    case EntryType.SERVICE: return "TEACHING SESSION"
    case EntryType.JOB: return "LOOKING FOR A DANCER"
    case EntryType.TICKET: return "SELL A TICKET"
    default: return ""
  }
}

export const likeEntry = (entryId: string, entryType: EntryType, isLike: boolean) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.LIKE_ENTRY_TRY })

    const options = await optionsMaker('Post', { isLike }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.LIKE_ENTRY_ERROR, error: "no options" })
      return
    }
    const uid = getState().userReducer.user?.uid

    try {
      const res = await fetch(`${BASE_DOMAIN}/${entryType}/${entryId}/like`, options)
      const response = await res.json()

      dispatch({
        type: constants.LIKE_ENTRY_RESPONSE,
        entryType,
        entryId,
        uid,
        isLike,
        response: response,
      })

    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.LIKE_ENTRY_ERROR, error: error })
    }
  }
}

export const sendComment = (entryId: string, entryType: EntryType, text: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.SEND_COMMENT_TRY })

    const options = await optionsMaker('Post', { text }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.SEND_COMMENT_ERROR, error: "no options" })
      return
    }
    const uid = getState().userReducer.user?.uid

    try {
      const res = await fetch(`${BASE_DOMAIN}/${entryType.toString()}/${entryId}/addComment`, options)
      const response = await res.json()

      dispatch({
        type: constants.SEND_COMMENT_RESPONSE,
        entryId,
        uid,
        text,
        response: response,
      })

    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.SEND_COMMENT_ERROR, error: error })
    }
  }
}

export const deleteEntry = (entryId: string, entryType: EntryType) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.DELETE_ENTRY_TRY, entryId })
    const accessToken = getState().userReducer.token
    // const options = {
    //   method: 'Post',
    //   body: JSON.stringify({ entryId }),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Post', { entryId }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.DELETE_ENTRY_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(BASE_DOMAIN + '/entry/delete', options)
      const response = await res.json()

      dispatch({
        type: constants.DELETE_ENTRY_RESPONSE,
        entryType,
        entryId,
        response: response,
      })
      if (response.success) dispatch({ type: constants.GO_TO_PAGE, page: '/' })
      if (response.success) {
        dispatch({ type: constants.GO_TO_PAGE, page: '/' })
      }
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.DELETE_ENTRY_ERROR, error: error })
    }
  }
}

export const clearOldData = (force?: boolean, entryType?: EntryType) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({
      type: constants.CLEAR_OLD_DATA,
      force,
      entryType,
    })
  }
}

export const runActions = async (actions: (() => any)[] | (() => any), dispatch: AppDispatch) => {
  await dispatch(updateToken())
  if (!Array.isArray(actions)) actions = [actions]
  for (const action of actions) {
    await dispatch(action())
  }
}

export const generatePassword = (length: number) => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const setLastGeneralRefresh = (lastGeneralRefresh: number) => ({
  type: constants.SET_LAST_GENERAL_REFRESH,
  lastGeneralRefresh
})